<template>
  <BaseTemplate app-name="Gestão de Usuários" page-title="">
    <template #content>
      <div v-if="carregado" class="w-full py-6 px-4 md:px-8">
        <!-- Cabeçalho -->
        <button @click="voltar"
          class="hidden md:inline-flex mb-5 items-center gap-2 bg-blue-500 dark:bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors dark:hover:bg-blue-700 shadow-sm">
          <SquareArrowLeft class="w-5 h-5" />
          <span>Voltar</span>
        </button>

        <!-- Banner de aviso -->
        <div v-if="showBanner" class="mb-4 p-4 rounded-lg border-l-4" 
             :class="{
               'bg-blue-50 border-blue-400 text-blue-800 dark:bg-blue-900 dark:text-blue-200': bannerType === 'info',
               'bg-green-50 border-green-400 text-green-800 dark:bg-green-900 dark:text-green-200': bannerType === 'success',
               'bg-yellow-50 border-yellow-400 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200': bannerType === 'warning',
               'bg-red-50 border-red-400 text-red-800 dark:bg-red-900 dark:text-red-200': bannerType === 'error'
             }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="flex-shrink-0">
                <svg v-if="bannerType === 'info'" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
                <svg v-else-if="bannerType === 'success'" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
                <svg v-else-if="bannerType === 'warning'" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                <svg v-else-if="bannerType === 'error'" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium">{{ bannerMessage }}</p>
              </div>
            </div>
            <button @click="showBanner = false" class="ml-4 flex-shrink-0">
              <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Cabeçalho responsivo -->
      <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <h1 class="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-white">
          <Calendar class="w-6 h-6 text-blue-500" />
          Gestão de Folgas e Plantões </h1>

        <!-- Menu de seleção de módulo -->
        <div class="flex items-center gap-4">
  <button
    @click="toggleModule"
    type="button"
    class="flex items-center gap-2 px-4 py-2 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-900"
    :class="{
      'bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 focus:ring-blue-500': selectedModule === 'folgas',
      'bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300 focus:ring-green-500': selectedModule === 'plantao'
    }"
  >
    <Calendar v-if="selectedModule === 'folgas'" class="w-5 h-5" />
    <User v-if="selectedModule === 'plantao'" class="w-5 h-5" />

    <span class="text-sm font-medium">
      {{ selectedModule === 'folgas' ? 'Visualizando Folgas' : 'Visualizando Plantão' }}
    </span>
  </button>
</div>
      </div>

      <!-- Botões do módulo Folgas -->
      <div v-if="selectedModule === 'folgas'" class="flex flex-wrap gap-2 mb-6">
        <button v-if="isResponsible" @click="openGroupModal()" class="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <Users class="w-4 h-4" />
          <span class="hidden sm:inline">Novo Grupo</span>
        </button>
        <button v-if="isResponsible" @click="openBalanceModal()" class="flex items-center justify-center gap-2 bg-purple-500 hover:bg-purple-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <ClipboardList class="w-4 h-4" />
          <span class="hidden sm:inline">Controle de Folgas</span>
        </button>
        <button @click="openRequestModal()" class="flex items-center justify-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <CalendarPlus class="w-4 h-4" />
          <span class="hidden sm:inline">Nova Solicitação</span>
        </button>
      </div>

      <!-- Botões do módulo Plantão -->
      <div v-if="selectedModule === 'plantao'" class="flex flex-wrap gap-2 mb-6">
        <button v-if="isResponsible" @click="openOnCallOrganizeModal()" class="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <CalendarPlus class="w-4 h-4" />
          <span class="hidden sm:inline">Organizar Plantão</span>
        </button>
        <button @click="openOnCallSwapModal()" class="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <ArrowLeftRight class="w-4 h-4" />
          <span class="hidden sm:inline">Solicitar Troca</span>
        </button>
        <button v-if="isResponsible" @click="openAvailabilityModal()" class="flex items-center gap-2 bg-purple-500 hover:bg-purple-600 text-white px-3 py-2 rounded-lg shadow-sm text-sm">
          <Calendar class="w-4 h-4" />
          <span class="hidden sm:inline">Disponibilidade</span>
        </button>
      </div>

        <!-- Abas de navegação com scroll horizontal em mobile -->
        <div class="flex border-b border-gray-200 dark:border-gray-700 mb-6 overflow-x-auto scrollbar-none">
          <button @click="activeTab = 'requests'"
            class="py-2 px-4 font-medium text-sm focus:outline-none whitespace-nowrap"
            :class="activeTab === 'requests' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 dark:text-gray-400 hover:text-blue-500'">
            Solicitações
          </button>
          <button @click="activeTab = 'calendar'"
            class="py-2 px-4 font-medium text-sm focus:outline-none whitespace-nowrap"
            :class="activeTab === 'calendar' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 dark:text-gray-400 hover:text-blue-500'">
            Calendário
          </button>
          <button v-if="isResponsible" @click="activeTab = 'groups'"
            class="py-2 px-4 font-medium text-sm focus:outline-none whitespace-nowrap"
            :class="activeTab === 'groups' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 dark:text-gray-400 hover:text-blue-500'">
            Grupos
          </button>
        </div>

        <!-- Filtros responsivos -->
        <div v-if="activeTab === 'requests'" class="flex flex-col sm:flex-row gap-4 mb-6">
          <div class="w-full sm:w-1/2 flex gap-2">
            <input v-model="filter" type="text" placeholder="Buscar por nome, data ou motivo..."
              class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
          </div>
          <div class="w-full sm:w-1/2 flex flex-wrap gap-2 justify-start sm:justify-end">
            <select v-model="statusFilter"
              class="border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 text-sm">
              <option value="all">Todos os status</option>
              <option value="pending">Aguardando</option>
              <option value="approved">Aprovadas</option>
              <option value="rejected">Rejeitadas</option>
            </select>
            <select v-if="isResponsible && groups.length > 0" v-model="selectedGroupId"
              class="border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500 text-sm">
              <option value="all">Todos os grupos</option>
              <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
          </div>
        </div>

        <!-- Conteúdo da aba Solicitações -->
        <div v-if="activeTab === 'requests'">
          <!-- Tabela para desktop -->
          <div
            class="hidden md:block bg-white dark:bg-gray-800 rounded-lg shadow overflow-x-auto dark:text-white text-gray-800">
            <table class="w-full">
              <thead
                class="bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 text-white dark:text-gray-100 text-sm uppercase tracking-wide rounded-t-lg">
                <tr>
                  <th @click="ordenarPor('nome')" class="cursor-pointer px-4 py-3 text-left">
                    Colaborador <span v-if="colunaOrdenada === 'nome'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                  </th>
                  <th @click="ordenarPor('data')" class="cursor-pointer px-4 py-3 text-left">
                    Data <span v-if="colunaOrdenada === 'data'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                  </th>
                  <th @click="ordenarPor('motivo')" class="cursor-pointer px-4 py-3 text-left">
                    Motivo <span v-if="colunaOrdenada === 'motivo'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                  </th>
                  <th @click="ordenarPor('status')" class="cursor-pointer px-4 py-3 text-left">
                    Status <span v-if="colunaOrdenada === 'status'">{{ ordemAscendente ? '🠕' : '🠗' }}</span>
                  </th>
                  <th class="px-4 py-3 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="request in requests" :key="request.id"
                  class="border-b dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                  
                  <td class="px-4 py-3">
                    <div class="flex items-center gap-2">
                      <span v-if="request.type === 'folga'" title="Solicitação de Folga" class="text-blue-500">
                        <CalendarPlus class="w-4 h-4" />
                      </span>
                      <span v-if="request.type === 'troca'" title="Solicitação de Troca de Plantão" class="text-green-500">
                        <ArrowLeftRight class="w-4 h-4" />
                      </span>
                      <span>{{ request.user_name }}</span>
                    </div>
                  </td>

                  <td class="px-4 py-3">{{ formatDate(request.date) }}</td>
                  
                  <td class="px-4 py-3 truncate max-w-[200px]">{{ request.reason }}</td>
                  
                  <td class="px-4 py-3">
                    <span class="px-2 py-1 text-xs rounded-full font-medium" :class="{
                      'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200': request.status === 'pending',
                      'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200': request.status === 'approved',
                      'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200': request.status === 'rejected'
                    }">
                      {{ getStatusText(request.status) }}
                    </span>
                  </td>

                  <td class="px-4 py-3 text-center">
                    <div class="flex justify-center space-x-2">

                      <template v-if="request.type === 'folga' && isResponsible && request.status === 'pending' && request.user_id !== userStore.id">
                        <button @click="approveRequest(request)"
                          class="flex items-center gap-1 text-green-500 hover:text-green-700"
                          :disabled="isApprovingRequest">
                          <CheckIcon class="w-4 h-4" /> Aprovar
                        </button>
                        <button @click="openRejectModal(request)"
                          class="flex items-center gap-1 text-red-500 hover:text-red-700"
                          :disabled="isRejectingRequest">
                          <XIcon class="w-4 h-4" /> Rejeitar
                        </button>
                      </template>
                      
                      <template v-if="request.type === 'troca' && isResponsible && request.status === 'pending'">
                          <button @click="approveSwapRequest(request)"
                            class="flex items-center gap-1 text-green-500 hover:text-green-700"
                            :disabled="isApprovingRequest">
                            <CheckIcon class="w-4 h-4" /> Aprovar Troca
                          </button>
                          <button @click="rejectSwapRequest(request)"
                            class="flex items-center gap-1 text-red-500 hover:text-red-700"
                            :disabled="isRejectingRequest">
                            <XIcon class="w-4 h-4" /> Rejeitar Troca
                          </button>
                      </template>

                    </div>
                  </td>
                </tr>
                <tr v-if="requests.length === 0">
                  <td colspan="5" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                    Nenhuma solicitação encontrada
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Cards para mobile -->
          <div class="md:hidden space-y-4">
            <div v-for="request in requests" :key="request.id"
              class="bg-white dark:bg-gray-800 shadow rounded-xl p-4 border border-gray-100 dark:border-gray-700 transition-all hover:shadow-md">
              <div class="flex justify-between items-center mb-2">
                <h3 class="text-base font-bold text-gray-900 dark:text-white truncate">
                  {{ request.user_name }}
                </h3>
                <span class="px-2 py-1 text-xs rounded-full font-medium" :class="{
                  'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200': request.status === 'pending',
                  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200': request.status === 'approved',
                  'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200': request.status === 'rejected'
                }">
                  {{ getStatusText(request.status) }}
                </span>
              </div>
              <div class="space-y-1 text-sm">
                <p class="text-gray-700 dark:text-gray-300"><span class="font-medium">Data:</span> {{
                  formatDate(request.date) }}
                </p>
                <p class="text-gray-700 dark:text-gray-300"><span class="font-medium">Motivo:</span> {{ request.reason
                  }}</p>
              </div>
              <div v-if="request.comments && request.comments.length > 0"
                class="mt-3 pt-2 border-t border-gray-100 dark:border-gray-700">
                <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Comentários:</p>
                <div class="max-h-20 overflow-y-auto">
                  <div v-for="(comment, index) in request.comments" :key="index"
                    class="ml-2 mt-1 border-l-2 border-gray-300 pl-2">
                    <p class="text-xs text-gray-500">{{ getUserName(comment.userId) }} - {{
                      formatDateTime(comment.timestamp) }}
                    </p>
                    <p class="text-xs text-gray-700 dark:text-gray-300">{{ comment.text }}</p>
                  </div>
                </div>
              </div>
              <div class="flex items-center justify-end mt-3 pt-2 border-t border-gray-100 dark:border-gray-700 gap-3">
                <template
                  v-if="request.type === 'folga' && isResponsible && request.status === 'pending' && (request.userId || request.user_id) !== userStore.id">
                  <button @click="approveRequest(request)"
                    class="flex items-center gap-1 text-green-500 hover:text-green-700 text-sm"
                    :disabled="isApprovingRequest">
                    <CheckIcon class="w-4 h-4" />
                    <span v-if="isApprovingRequest">Aprovando...</span>
                    <span v-else>Aprovar</span>
                  </button>
                  <button @click="openRejectModal(request)"
                    class="flex items-center gap-1 text-red-500 hover:text-red-700 text-sm"
                    :disabled="isRejectingRequest">
                    <XIcon class="w-4 h-4" />
                    <span v-if="isRejectingRequest">Rejeitando...</span>
                    <span v-else>Rejeitar</span>
                  </button>
                </template>

                <template v-else-if="request.type === 'troca' && isResponsible && request.status === 'pending'">
                  <button @click="approveSwapRequest(request)"
                    class="flex items-center gap-1 text-green-500 hover:text-green-700 text-sm"
                    :disabled="isApprovingRequest">
                    <CheckIcon class="w-4 h-4" />
                    <span v-if="isApprovingRequest">Aprovando...</span>
                    <span v-else>Aprovar troca</span>
                  </button>
                  <button @click="rejectSwapRequest(request)"
                    class="flex items-center gap-1 text-red-500 hover:text-red-700 text-sm"
                    :disabled="isRejectingRequest">
                    <XIcon class="w-4 h-4" />
                    <span v-if="isRejectingRequest">Rejeitando...</span>
                    <span v-else>Rejeitar troca</span>
                  </button>
                </template>

                <template v-else>
                  <button @click="viewRequestDetails(request)"
                    class="flex items-center gap-1 text-blue-500 hover:text-blue-700 text-sm">
                    <EyeIcon class="w-4 h-4" /> Detalhes
                  </button>
                </template>

                <template v-if="isResponsible">
                  <button @click="openEditDateModal(request)"
                    class="flex items-center gap-1 text-orange-500 hover:text-orange-700 transition-colors text-sm">
                    <Edit2Icon class="w-4 h-4" /> Editar
                  </button>
                </template>
              </div>
            </div>
            <div v-if="requests.length === 0"
              class="text-center text-gray-500 dark:text-gray-400 py-8 bg-white dark:bg-gray-800 rounded-lg shadow p-4">
              Nenhuma solicitação encontrada
            </div>
          </div>

          <!-- Paginação responsiva -->
          <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
            <div class="flex items-center gap-2 justify-center">
              <button :disabled="currentPage === 1" @click="prevPage"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
              <span class="text-sm text-gray-700 dark:text-gray-200">Página {{ currentPage }} de {{ totalPages }}</span>
              <button :disabled="currentPage === totalPages" @click="nextPage"
                class="px-3 py-1 rounded bg-blue-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
            </div>
            <div class="flex items-center gap-2 justify-center">
              <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
              <select id="page-size" v-model.number="itemsPerPage" @change="currentPage = 1; loadRequests()"
                class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </select>
              <span v-if="totalCount !== undefined && totalCount !== null"
                class="text-xs text-gray-500 dark:text-gray-400">Total:
                {{ totalCount }}</span>
            </div>
          </div>
        </div>

        <!-- Conteúdo da aba Calendário -->
        <div v-if="activeTab === 'calendar'" class="flex justify-center items-center min-h-[400px]">
          <CalendarioFolgas :folgas="requests.map(r => ({
            id: r.id,
            user_name: getUserName(r.userId),
            date: r.date,
            reason: r.reason,
            status: r.status
          }))" 
          :plantoes="onCallDuties" 
          v-model:currentDate="currentDate" />
        </div>

        <!-- Conteúdo da aba Grupos (apenas para coordenadores) -->
        <div v-if="activeTab === 'groups' && isResponsible">
          <!-- Versão para desktop -->
          <div class="hidden md:block bg-white dark:bg-gray-800 rounded-lg shadow overflow-x-auto">
            <table class="w-full min-w-[640px]">
              <thead
                class="bg-gradient-to-r from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 text-white dark:text-gray-100 text-sm uppercase tracking-wide rounded-t-lg">
                <tr>
                  <th class="px-4 py-3 text-left">Nome do Grupo</th>
                  <th class="px-4 py-3 text-left">Membros</th>
                  <th class="px-4 py-3 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="group in groups" :key="group.id"
                  class="border-b dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-gray-600">
                  <td class="px-4 py-3 font-medium dark:text-gray-100">{{ group.name }}</td>
                  <td class="px-4 py-3">
                    <div class="flex flex-wrap gap-1">
                      <span v-for="member in group.members" :key="member.id"
                        class="px-2 py-1 text-xs bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full">
                        {{ member.name }}
                      </span>
                    </div>
                  </td>
                  <td class="px-4 py-3 text-center">
                    <div class="flex justify-center space-x-3">
                      <button @click="openGroupModal(group)"
                        class="flex items-center gap-1 text-blue-500 hover:text-blue-700 transition-colors">
                        <Edit2Icon class="w-4 h-4" /> Editar
                      </button>
                      <button @click="deleteGroup(group.id)"
                        class="flex items-center gap-1 text-red-500 hover:text-red-700 transition-colors">
                        <Trash2Icon class="w-4 h-4" /> Excluir
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="groups.length === 0">
                  <td colspan="3" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                    Nenhum grupo encontrado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Cards para mobile -->
          <div class="md:hidden space-y-4">
            <div v-for="group in groups" :key="group.id"
              class="bg-white dark:bg-gray-800 shadow rounded-xl p-4 border border-gray-100 dark:border-gray-700">
              <div class="flex justify-between items-center mb-3">
                <h3 class="font-medium text-gray-900 dark:text-white">{{ group.name }}</h3>
                <div class="flex gap-2">
                  <button @click="openGroupModal(group)"
                    class="p-1.5 bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 rounded-full hover:bg-blue-200 dark:hover:bg-blue-800">
                    <Edit2Icon class="w-4 h-4" />
                  </button>
                  <button @click="deleteGroup(group.id)"
                    class="p-1.5 bg-red-100 dark:bg-red-900 text-red-600 dark:text-red-300 rounded-full hover:bg-red-200 dark:hover:bg-red-800">
                    <Trash2Icon class="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div class="flex flex-wrap gap-1.5 mt-2">
                <span v-for="member in group.members" :key="member.id"
                  class="px-2 py-1 text-xs bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full">
                  {{ member.name }}
                </span>
              </div>

            </div>
            <div v-if="groups.length === 0"
              class="text-center text-gray-500 dark:text-gray-400 py-8 bg-white dark:bg-gray-800 rounded-lg shadow p-4">
              Nenhum grupo encontrado
            </div>
          </div>
        </div>

        <!-- Mensagem de erro -->
        <p v-if="error" class="text-red-500 text-center mb-4 mt-4 p-2 bg-red-50 dark:bg-red-900/20 rounded-lg">{{ error
          }}</p>

        <!-- Modal de Nova/Editar Solicitação -->
        <div v-if="showRequestModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeRequestModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <CalendarPlus class="w-5 h-5 text-blue-500" />
              {{ isEditMode ? 'Editar Solicitação' : 'Nova Solicitação de Folga' }}
            </h2>

            <!-- Alerta de erro dentro do modal -->
            <div v-if="showErrorPopup"
              class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative mb-4">
              <strong>Erro:</strong> {{ errorMessage }}
              <button @click="showErrorPopup = false" class="absolute top-0 right-0 px-3 py-1">
                &times;
              </button>
            </div>

            <div v-if="getUserBalance(userStore.id).available <= 0"
              class="mb-4 p-3 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 rounded">
              Atenção: Se você não possuir folgas disponíveis. Esta solicitação entrará como saldo negativo e será
              descontada
              quando você receber novas folgas.
            </div>

            <form @submit.prevent="saveRequest">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Data da Folga</label>
                <input v-model="currentRequest.date" type="date"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white text-gray-600"
                  :min="tomorrow" required />
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo</label>
                <input
                  v-model="currentRequest.reason"
                  type="text"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Ex.: Folga referente ao plantão de sábado 23/03"
                />
              </div>

              <div class="mb-4" v-if="showGroupSelect">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Grupo</label>
                <select v-model="currentRequest.groupId"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  required>
                  <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
                </select>
              </div>

              <div class="flex justify-end space-x-3 mt-6">
                <button type="button" @click="closeRequestModal"
                  class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingRequest">
                  <XIcon class="w-4 h-4" /> Cancelar
                </button>
                <button type="submit"
                  class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingRequest">
                  <SaveIcon class="w-4 h-4" />
                  <span v-if="isSavingRequest">Salvando...</span>
                  <span v-else>Salvar</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Modal de Rejeição -->
        <div v-if="showRejectModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeRejectModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <XCircle class="w-5 h-5 text-red-500" />
              Rejeitar Solicitação
            </h2>

            <form @submit.prevent="rejectRequest">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo da
                  Rejeição</label>
                <textarea v-model="rejectReason" rows="3"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Informe o motivo da rejeição" required></textarea>
              </div>

              <div class="flex justify-end space-x-3 mt-6">
                <button type="button" @click="closeRejectModal"
                  class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isRejectingRequest">
                  <XIcon class="w-4 h-4" /> Cancelar
                </button>
                <button type="submit"
                  class="flex items-center gap-1 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isRejectingRequest">
                  <XIcon class="w-4 h-4" />
                  <span v-if="isRejectingRequest">Rejeitando...</span>
                  <span v-else>Rejeitar</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Modal de Detalhes da Solicitação -->
        <div v-if="showDetailsModal"
          class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-60 p-4"
          @click.self="closeDetailsModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <Calendar class="w-5 h-5 text-blue-500" />
              Detalhes da Solicitação
            </h2>

            <div class="space-y-4">
              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Colaborador</p>
                <p class="text-gray-900 dark:text-white">{{ getUserName(selectedRequest?.userId) }}</p>
              </div>

              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Data</p>
                <p class="text-gray-900 dark:text-white">{{ formatDate(selectedRequest?.date) }}</p>
              </div>

              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Motivo</p>
                <p class="text-gray-900 dark:text-white">{{ selectedRequest?.reason }}</p>
              </div>

              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Status</p>
                <span class="px-2 py-1 text-xs rounded-full" :class="{
                  'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200': selectedRequest?.status === 'pending',
                  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200': selectedRequest?.status === 'approved',
                  'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200': selectedRequest?.status === 'rejected'
                }">
                  {{ getStatusText(selectedRequest?.status) }}
                </span>
              </div>

              <!-- Comentários -->
              <div v-if="selectedRequest?.comments && selectedRequest.comments.length > 0">
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">Comentários</p>
                <div
                  class="space-y-2 max-h-40 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg p-3">
                  <div v-for="(comment, index) in selectedRequest.comments" :key="index"
                    class="border-b border-gray-200 dark:border-gray-700 pb-2 last:border-0 last:pb-0">
                    <div class="flex justify-between items-center mb-1">
                      <span class="font-medium text-sm text-gray-800 dark:text-gray-200">{{ getUserName(comment.userId)
                        }}</span>
                      <span class="text-xs text-gray-500">{{ formatDateTime(comment.timestamp) }}</span>
                    </div>
                    <p class="text-sm text-gray-700 dark:text-gray-300">{{ comment.text }}</p>
                  </div>
                </div>
              </div>

              <!-- Adicionar comentário (apenas para coordenadores) -->
              <div v-if="isResponsible && selectedRequest">
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">Adicionar Comentário</p>
                <div class="flex gap-2">
                  <textarea v-model="newComment" rows="2"
                    class="w-full border rounded-lg px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    placeholder="Escreva um comentário..."></textarea>
                  <button @click="addComment"
                    class="px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg self-end transition-colors"
                    :disabled="!newComment.trim()">
                    <MessageSquare class="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>

            <div class="flex justify-end mt-6">
              <button @click="closeDetailsModal"
                class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors">
                <XIcon class="w-4 h-4" /> Fechar
              </button>
            </div>
          </div>
        </div>

        <!-- Modal de Novo/Editar Grupo -->
        <div v-if="showGroupModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeGroupModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <Users class="w-5 h-5 text-blue-500" />
              {{ isEditGroupMode ? 'Editar Grupo' : 'Novo Grupo' }}
            </h2>

            <!-- Alerta de erro dentro do modal -->
            <div v-if="showErrorPopup"
              class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative mb-4">
              <strong>Erro:</strong> {{ errorMessage }}
              <button @click="showErrorPopup = false" class="absolute top-0 right-0 px-3 py-1">
                &times;
              </button>
            </div>

            <form @submit.prevent="saveGroup">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nome do Grupo</label>
                <input v-model="currentGroup.name" type="text"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Digite o nome do grupo" required />
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Membros</label>
                <input v-model="groupUserFilter" type="text" placeholder="Buscar colaborador..."
                  class="w-full border rounded-lg px-3 py-2 mb-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white text-sm" />
                <div class="border border-gray-300 dark:border-gray-600 rounded-lg p-2 max-h-40 overflow-y-auto">
                  <div v-for="user in filteredUsersForGroup" :key="user.id"
                    class="flex items-center p-2 hover:bg-gray-50 dark:hover:bg-gray-700 rounded transition-colors">
                    <input type="checkbox" :id="`user-${user.id}`" :value="Number(user.id)"
                      v-model="currentGroup.members"
                      class="mr-2 h-4 w-4 rounded border-gray-400 dark:border-gray-500 accent-blue-600 dark:accent-blue-400" />
                    <label :for="`user-${user.id}`" class="cursor-pointer text-gray-800 dark:text-gray-200">{{ user.name
                      }}</label>
                  </div>
                </div>
              </div>

              <div class="flex justify-end space-x-3 mt-6">
                <button type="button" @click="closeGroupModal"
                  class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingGroup">
                  <XIcon class="w-4 h-4" /> Cancelar
                </button>
                <button type="submit"
                  class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingGroup">
                  <SaveIcon class="w-4 h-4" />
                  <span v-if="isSavingGroup">Salvando...</span>
                  <span v-else>Salvar</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Modal de Controle de Folgas -->
        <div v-if="showBalanceModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeBalanceModal">
          <div
            class="bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg shadow-lg w-full max-w-4xl animate-fade-in relative max-h-[90vh] overflow-y-auto">
            <div class="flex items-center justify-between mb-4">
              <span class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white">
                <ClipboardList class="w-5 h-5 text-purple-500" />
                Controle de Folgas
              </span>
              <button @click="closeBalanceModal" aria-label="Fechar"
                class="ml-2 p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400">
                <XIcon class="w-5 h-5 text-gray-500 dark:text-gray-300" />
              </button>
            </div>

            <!-- Alerta de erro dentro do modal -->
            <div v-if="showErrorPopup"
              class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded relative mb-4">
              <strong>Erro:</strong> {{ errorMessage }}
              <button @click="showErrorPopup = false" class="absolute top-0 right-0 px-3 py-1">
                &times;
              </button>
            </div>

            <!-- Filtro de usuários -->
            <div class="mb-4">
              <input v-model="balanceFilter" type="text" placeholder="Buscar colaborador..."
                class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
            </div>

            <!-- Conteúdo com rolagem para mobile -->
            <div class="overflow-y-auto max-h-[70vh] md:max-h-[75vh] p-2 pb-24 md:p-6 md:pb-6">
              <!-- Tabela de controle de folgas para desktop -->
              <div class="hidden md:block overflow-x-auto">
                <table class="w-full">
                  <thead
                    class="bg-gradient-to-r from-purple-500 to-purple-600 dark:from-purple-600 dark:to-purple-700 text-white text-sm uppercase tracking-wide rounded-t-lg">
                    <tr>
                      <th class="px-4 py-3 text-left">Colaborador</th>
                      <th class="px-4 py-3 text-center">Folgas Disponíveis</th>
                      <th class="px-4 py-3 text-center">Folgas Pendentes</th>
                      <th class="px-4 py-3 text-center">Folgas Utilizadas</th>
                      <th class="px-4 py-3 text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in filteredUsersForBalance" :key="user.id"
                      class="border-b dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors text-gray-900">
                      <td class="px-4 py-3 font-medium dark:text-gray-100">{{ user.name }}</td>
                      <td class="px-4 py-3 text-center">
                        <span :class="{
                          'px-2 py-1 rounded-full text-xs font-medium': true,
                          'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200': getUserBalance(user.id).available > 0,
                          'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200': getUserBalance(user.id).available < 0,
                          'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200': getUserBalance(user.id).available === 0
                        }">
                          {{ getUserBalance(user.id).available }}
                        </span>
                      </td>
                      <td class="px-4 py-3 text-center">
                        <span
                          class="px-2 py-1 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 rounded-full text-xs font-medium">
                          {{ getUserBalance(user.id).pending }}
                        </span>
                      </td>
                      <td class="px-4 py-3 text-center">
                        <span
                          class="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-xs font-medium">
                          {{ getUserBalance(user.id).used }}
                        </span>
                      </td>
                      <td class="px-4 py-3 text-center">
                        <div class="flex justify-center space-x-2">
                          <button v-if="isResponsible" @click="openAdjustBalanceModal(user)"
                            class="flex items-center gap-1 text-purple-500 hover:text-purple-700 transition-colors">
                            <Edit2Icon class="w-4 h-4" /> Ajustar
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="filteredUsersForBalance.length === 0">
                      <td colspan="5" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                        Nenhum colaborador encontrado
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Cards para mobile -->
              <div class="md:hidden space-y-4">
                <div v-for="user in filteredUsersForBalance" :key="user.id"
                  class="bg-white dark:bg-gray-900 shadow-lg rounded-xl p-4 border border-gray-100 dark:border-gray-700">
                  <div class="flex justify-between items-center mb-3">
                    <h3 class="text-base font-bold text-gray-900 dark:text-white">
                      {{ user.name }}
                    </h3>
                    <button v-if="isResponsible" @click="openAdjustBalanceModal(user)"
                      class="p-1.5 bg-purple-100 dark:bg-purple-900 text-purple-600 dark:text-purple-300 rounded-full hover:bg-purple-200 dark:hover:bg-purple-800">
                      <Edit2Icon class="w-4 h-4" />
                    </button>
                  </div>
                  <div class="grid grid-cols-3 gap-2 mt-2">
                    <div class="flex flex-col items-center p-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
                      <span class="text-xs text-gray-500 dark:text-gray-400 mb-1">Disponíveis</span>
                      <span :class="{
                        'px-2 py-1 rounded-full text-xs font-medium': true,
                        'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200': getUserBalance(user.id).available > 0,
                        'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200': getUserBalance(user.id).available < 0,
                        'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200': getUserBalance(user.id).available === 0
                      }">
                        {{ getUserBalance(user.id).available }}
                      </span>
                    </div>
                    <div class="flex flex-col items-center p-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
                      <span class="text-xs text-gray-500 dark:text-gray-400 mb-1">Pendentes</span>
                      <span
                        class="px-2 py-1 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 rounded-full text-xs font-medium">
                        {{ getUserBalance(user.id).pending }}
                      </span>
                    </div>
                    <div class="flex flex-col items-center p-2 bg-gray-50 dark:bg-gray-800 rounded-lg">
                      <span class="text-xs text-gray-500 dark:text-gray-400 mb-1">Utilizadas</span>
                      <span
                        class="px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 rounded-full text-xs font-medium">
                        {{ getUserBalance(user.id).used }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="filteredUsersForBalance.length === 0"
                  class="text-center text-gray-500 dark:text-gray-400 py-8 bg-white dark:bg-gray-800 rounded-lg shadow p-4">
                  Nenhum colaborador encontrado
                </div>
              </div>
            </div>


          </div>
        </div>

        <!-- Modal de Ajuste de Saldo de Folgas -->
        <div v-if="showAdjustBalanceModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeAdjustBalanceModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <ClipboardList class="w-5 h-5 text-purple-500" />
              Ajustar Folgas - {{ selectedUserForBalance?.name }}
            </h2>

            <form @submit.prevent="saveBalanceAdjustment">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Adicionar/Remover Folgas
                  <span class="text-xs text-gray-500 dark:text-gray-400 block">Valor positivo adiciona, negativo remove</span>
                </label>
                <div class="flex items-center">
                  <button type="button" @click="decrementBalance"
                    class="px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-l-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">
                    <Minus class="w-4 h-4" />
                  </button>
                  <input v-model="balanceAdjustment" type="number"
                    class="w-full border-y border-x-0 px-4 py-2 text-center dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    required />
                  <button type="button" @click="incrementBalance"
                    class="px-3 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-r-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors">
                    <Plus class="w-4 h-4" />
                  </button>
                </div>
                <!-- Aviso de saldo negativo -->
                <div v-if="willBeNegative" class="mt-2 p-3 bg-yellow-100 dark:bg-yellow-900 border-l-4 border-yellow-500 text-yellow-800 dark:text-yellow-200 rounded text-sm">
                  <strong>Atenção:</strong> Este ajuste resultará em um saldo negativo de {{ calculatedBalance }} dias. 
                  Saldo atual: {{ getUserBalance(selectedUserForBalance.id).available }} dias + {{ balanceAdjustment }} (ajuste) = {{ calculatedBalance }} dias.
                </div>
              </div>

              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Motivo do Ajuste</label>
                <textarea v-model="balanceAdjustmentReason" rows="3"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  placeholder="Informe o motivo do ajuste" required></textarea>
              </div>

              <div class="flex justify-end space-x-3 mt-6">
                <button type="button" @click="closeAdjustBalanceModal"
                  class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingBalanceAdjustment">
                  <XIcon class="w-4 h-4" /> Cancelar
                </button>
                <button type="submit"
                  class="flex items-center gap-1 bg-purple-500 hover:bg-purple-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingBalanceAdjustment">
                  <SaveIcon class="w-4 h-4" />
                  <span v-if="isSavingBalanceAdjustment">Salvando...</span>
                  <span v-else>Salvar</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Modal de edição de data -->
        <div v-if="showEditDateModal"
          class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeEditDateModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="flex items-center gap-2 text-lg font-semibold text-gray-900 dark:text-white mb-4">
              <Edit2Icon class="w-5 h-5 text-orange-500" />
              Editar Data da Folga
            </h2>
            <form @submit.prevent="saveEditDate">
              <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Nova Data</label>
                <input v-model="editDateValue" type="date"
                  class="w-full border rounded-lg px-4 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                  required />
              </div>
              <div class="flex justify-end space-x-3 mt-6">
                <button type="button" @click="closeEditDateModal"
                  class="flex items-center gap-1 bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingEditDate">
                  <XIcon class="w-4 h-4" /> Cancelar
                </button>
                <button type="submit"
                  class="flex items-center gap-1 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors"
                  :disabled="isSavingEditDate">
                  <SaveIcon class="w-4 h-4" />
                  <span v-if="isSavingEditDate">Salvando...</span>
                  <span v-else>Salvar</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Modal de dia do calendário -->
        <div v-if="showDayModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          @click.self="closeDayModal">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full max-w-md animate-fade-in">
            <h2 class="text-lg font-semibold mb-4 text-gray-900 dark:text-white flex items-center gap-2">
              <Calendar class="w-5 h-5 text-blue-500" />
              Solicitações do dia {{ selectedDay?.day }}/{{ (selectedDay?.date.getMonth() + 1).toString().padStart(2,
              '0') }}/{{
                selectedDay?.date.getFullYear() }}
            </h2>
            <div v-if="dayRequests.length === 0" class="text-gray-500 dark:text-gray-400 text-center mb-4">
              Nenhuma solicitação para este dia.
            </div>
            <ul v-else class="space-y-2 max-h-60 overflow-y-auto">
              <li v-for="req in dayRequests" :key="req.id"
                class="flex items-center gap-2 justify-between bg-gray-50 dark:bg-gray-700 rounded p-2">
                <span class="font-medium text-gray-800 dark:text-gray-200 cursor-pointer hover:underline"
                  @click="viewRequestDetails(req)">
                  {{ getUserName(req.userId) }}
                </span>
                <span class="text-xs px-2 py-1 rounded-full font-medium" :class="{
                  'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200': req.status === 'pending',
                  'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200': req.status === 'approved',
                  'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200': req.status === 'rejected'
                }">
                  {{ getStatusText(req.status) }}
                </span>
              </li>
            </ul>
            <div class="flex justify-end mt-6">
              <button @click="closeDayModal"
                class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors">
                <XIcon class="w-4 h-4" /> Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex justify-center items-center h-screen">
        <div class="flex flex-col items-center gap-4">
          <div class="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          <p class="text-gray-500 dark:text-gray-400">Carregando...</p>
        </div>
      </div>

      <!-- Modal de Organização de Plantões -->
      <div v-if="showOnCallOrganizeModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Organizar Plantões do Mês</h3>
            <button @click="closeOnCallOrganizeModal" class="text-gray-400 hover:text-gray-600">
              <XIcon class="w-6 h-6" />
            </button>
          </div>
          
          <!-- Formulário de Organização -->
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Mês</label>
                <select v-model="organizeForm.month" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <option v-for="month in months" :key="month.value" :value="month.value">{{ month.label }}</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Ano</label>
                <select v-model="organizeForm.year" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Grupo</label>
              <select v-model="organizeForm.groupId" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <option value="">Selecione um grupo</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
              </select>
            </div>
            
            <!-- Lista de Sábados do Mês -->
            <div v-if="organizeForm.groupId" class="border rounded-lg p-4 dark:border-gray-600">
              <h4 class="font-medium text-gray-900 dark:text-white mb-3">Definir Plantões para os Sábados (2 colaboradores por plantão)</h4>
              <div class="space-y-3 max-h-64 overflow-y-auto">
                <div v-for="saturday in monthSaturdays" :key="saturday.date" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                  <div class="mb-2">
                    <span class="font-medium text-gray-900 dark:text-white">{{ formatDate(saturday.date) }}</span>
                    <span class="text-sm text-gray-500 dark:text-gray-400 ml-2">({{ saturday.label }})</span>
                  </div>
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div>
                      <label class="text-xs text-gray-600 dark:text-gray-400">Colaborador Principal:</label>
                      <select v-model="organizeForm.assignments[saturday.date]" class="w-full border rounded px-2 py-1 text-sm dark:bg-gray-600 dark:border-gray-500">
                        <option value="">Nenhum</option>
                        <option v-for="user in availableUsers" :key="user.id" :value="user.id">{{ user.name }}</option>
                      </select>
                    </div>
                    <div>
                      <label class="text-xs text-gray-600 dark:text-gray-400">Colaborador Secundário:</label>
                      <select v-model="organizeForm.assignments[saturday.date + '_secondary']" class="w-full border rounded px-2 py-1 text-sm dark:bg-gray-600 dark:border-gray-500">
                        <option value="">Nenhum</option>
                        <option v-for="user in availableUsers" :key="user.id" :value="user.id">{{ user.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Erro -->
            <div v-if="organizeError" class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">
              {{ organizeError }}
            </div>
            
            <!-- Sucesso -->
            <div v-if="organizeSuccess" class="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded">
              {{ organizeSuccess }}
            </div>
          </div>
          
          <div class="flex justify-end space-x-3 mt-6">
            <button @click="closeOnCallOrganizeModal" class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg">
              Cancelar
            </button>
            <button @click="saveOnCallOrganization" 
                    :disabled="isOrganizing || !organizeForm.groupId"
                    class="px-4 py-2 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 text-white rounded-lg">
              <span v-if="isOrganizing">Organizando...</span>
              <span v-else>Salvar Organização</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Modal de Solicitação de Troca -->
      <div v-if="showOnCallSwapModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Solicitar Troca de Plantão</h3>
            <button @click="closeOnCallSwapModal" class="text-gray-400 hover:text-gray-600">
              <XIcon class="w-6 h-6" />
            </button>
          </div>
          
          <!-- Formulário de Solicitação de Troca -->
          <form @submit.prevent="saveSwapRequest" class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Seu Plantão</label>
              <select v-model="swapForm.myDutyId" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white" required>
                <option value="">Selecione seu plantão</option>
                <option v-for="duty in myOnCallDuties" :key="duty.id" :value="duty.id">
                  {{ formatDate(duty.date) }} - {{ duty.group_name || 'Grupo não especificado' }}
                </option>
              </select>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Colaborador para Troca</label>
              <select v-model="swapForm.targetUserId" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white" required>
                <option value="">Selecione o colaborador</option>
                <option v-for="user in availableUsersForSwap" :key="user.id" :value="user.id">
                  {{ user.name }}
                </option>
              </select>
              <p v-if="availableUsersForSwap.length === 0 && swapForm.myDutyId" class="text-sm text-gray-500 mt-1">
                Nenhum colaborador disponível para troca neste grupo.
              </p>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Motivo da Troca</label>
              <textarea v-model="swapForm.reason" rows="3" 
                        class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                        placeholder="Informe o motivo da solicitação de troca" required></textarea>
            </div>
            
            <!-- Erro -->
            <div v-if="swapError" class="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">
              {{ swapError }}
            </div>
            
            <!-- Sucesso -->
            <div v-if="swapSuccess" class="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded">
              {{ swapSuccess }}
            </div>
          </form>
          
          <div class="flex justify-end space-x-3 mt-6">
            <button @click="closeOnCallSwapModal" class="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-lg">
              Cancelar
            </button>
            <button @click="saveSwapRequest" 
                    :disabled="isSwapping || !swapForm.myDutyId || !swapForm.targetUserId || !swapForm.reason"
                    class="px-4 py-2 bg-green-500 hover:bg-green-600 disabled:bg-green-300 text-white rounded-lg">
              <span v-if="isSwapping">Solicitando...</span>
              <span v-else>Solicitar Troca</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Modal de Disponibilidade e Escala Automática -->
      <div v-if="showAvailabilityModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          <div class="flex justify-between items-center mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Disponibilidade e Escala Automática</h3>
            <button @click="closeAvailabilityModal" class="text-gray-400 hover:text-gray-600">
              <XIcon class="w-6 h-6" />
            </button>
          </div>
          
          <!-- Seleção de Período e Grupo -->
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Inicial</label>
              <input v-model="availabilityForm.startDate" type="date" 
                     class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                     :min="today">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Final</label>
              <input v-model="availabilityForm.endDate" type="date" 
                     class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                     :min="availabilityForm.startDate || today">
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Grupo</label>
              <select v-model="availabilityForm.groupId" class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <option value="">Selecione um grupo</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>
          
          <!-- Lista de Colaboradores Disponíveis -->
          <div class="mb-6" v-if="availabilityForm.groupId">
            <h4 class="text-md font-medium text-gray-900 dark:text-white mb-3">Colaboradores</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 max-h-48 overflow-y-auto border rounded-lg p-3 dark:border-gray-600">
              <label v-for="user in availableUsersForGroup" :key="user.id" 
                     class="flex items-center space-x-2 p-2 rounded hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer">
                <input type="checkbox" 
                       :checked="availabilityForm.availableUsers.find(u => u.userId === user.id)?.available"
                        @change="toggleUserAvailability(user.id)"
                       class="rounded border-gray-300 text-red-600 focus:ring-red-500">
                <span class="text-sm text-gray-700 dark:text-gray-300">{{ user.name }}</span>
                <span v-if="availabilityForm.availableUsers.find(u => u.userId === user.id)?.unavailableReason" 
                      class="text-xs text-red-500 dark:text-red-400 ml-1">
                  ({{ availabilityForm.availableUsers.find(u => u.userId === user.id).unavailableReason }})
                </span>
              </label>
            </div>
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
              Todos os colaboradores estão disponíveis por padrão. Marque aqueles que estiverem indisponíveis (por período).
            </p>
          </div>
      
<div class="flex justify-end space-x-3">
  <button @click="closeAvailabilityModal" class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg">
    Cancelar
  </button>
  <button @click="generateAndSaveAutomaticScale"
    :disabled="isGeneratingScale || !availabilityForm.groupId" class="px-4 py-2 bg-purple-500 hover:bg-purple-600 disabled:bg-purple-300 text-white rounded-lg">
    <span v-if="isGeneratingScale">Gerando Escala...</span>
    <span v-else>Gerar Escala</span>
  </button>
  <button @click="saveAvailability"
    :disabled="isSavingAvailability || !availabilityForm.groupId" class="px-4 py-2 bg-green-500 hover:bg-green-600 disabled:bg-green-300 text-white rounded-lg">
    <span v-if="isSavingAvailability">Salvando...</span>
    <span v-else>Salvar</span>
  </button>
  </div>
        </div>
      </div>

    </template>
  </BaseTemplate>
</template>

<script setup>
import BaseTemplate from '../templates/BaseTemplate.vue';
import CalendarioFolgas from './CalendarioFolgas.vue';
import apiClient from '@/services/authService';
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import {
  Calendar,
  CalendarPlus,
  Check as CheckIcon,
  ClipboardList,
  Edit2Icon,
  Eye as EyeIcon,
  MessageSquare,
  Minus,
  Plus,
  Save as SaveIcon,
  SquareArrowLeft,
  Trash2Icon,
  Users,
  X as XIcon,
  XCircle,
  ArrowLeftRight,
  User
  
} from 'lucide-vue-next';
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()

// Router
const router = useRouter();
const voltar = () => router.back();

// Estado da aplicação
const activeTab = ref('requests');
const selectedModule = ref('folgas'); // Novo: módulo selecionado (folgas ou plantao)
const error = ref(null);
const filter = ref('');
const statusFilter = ref('all');
const selectedGroupId = ref('all');
const currentPage = ref(1);
const itemsPerPage = ref(10);
const newComment = ref('');
const balanceFilter = ref('');
const balanceAdjustment = ref(0);
const balanceAdjustmentReason = ref('');

// Estado para Plantão (On-call)
const onCallDuties = ref([]);
const onCallSwapRequests = ref([]);
const loadingOnCallDuties = ref(false);
const selectedMonth = ref(new Date().getMonth());
const selectedYear = ref(new Date().getFullYear());
const onCallFilter = ref('');
const onCallStatusFilter = ref('all');




// Estado para formulário de organização de plantões
const organizeForm = ref({
  month: new Date().getMonth(),
  year: new Date().getFullYear(),
  groupId: '',
  assignments: {}
});
const isOrganizing = ref(false);
const organizeError = ref('');
const organizeSuccess = ref('');

// Estado para formulário de solicitação de troca
const swapForm = ref({
  myDutyId: '',
  targetUserId: '',
  reason: ''
});
const isSwapping = ref(false);
const swapError = ref('');
const swapSuccess = ref('');
const availableUsersForSwap = ref([]);
const userOnCallDuties = ref([]);

// Estado para formulário de disponibilidade e escala automática
const availabilityForm = ref({
  startDate: '',
  endDate: '',
  groupId: '',
  availableUsers: []
});
const isGeneratingScale = ref(false);
const isSavingAvailability = ref(false);
const availabilityError = ref('');
const availabilitySuccess = ref('');

const autoScaleAssignments = ref({});

// Banner de aviso
const showBanner = ref(false);
const bannerMessage = ref('');
const bannerType = ref('info'); // 'info', 'success', 'warning', 'error'

const toggleModule = () => {
  selectedModule.value = selectedModule.value === 'folgas' ? 'plantao' : 'folgas'
}

// Função para mostrar banner de aviso
const showBannerMessage = (message, type = 'info') => {
  bannerMessage.value = message;
  bannerType.value = type;
  showBanner.value = true;
  
  // Auto-fechar após 5 segundos
  setTimeout(() => {
    showBanner.value = false;
  }, 5000);
}
// Modais
const showRequestModal = ref(false);
const showRejectModal = ref(false);
const showDetailsModal = ref(false);
const showGroupModal = ref(false);
const showBalanceModal = ref(false);
const showAdjustBalanceModal = ref(false);
const showOnCallOrganizeModal = ref(false);
const showOnCallSwapModal = ref(false);
const showAvailabilityModal = ref(false);
const showErrorPopup = ref(false);
const errorMessage = ref('');

// Dados para edição
const isEditMode = ref(false);
const isEditGroupMode = ref(false);
const currentRequest = ref({
  id: null,
  userId: null,
  groupId: null,
  date: '',
  reason: '',
  status: 'pending',
  comments: []
});
const currentGroup = ref({
  id: null,
  name: '',
  members: []
});
const selectedRequest = ref(null);
const rejectReason = ref('');
const selectedUserForBalance = ref(null);

// Calendário
const currentDate = ref(new Date());

// Variáveis para ordenação
const colunaOrdenada = ref('data');
const ordemAscendente = ref(false);
const ehResponsavel = ref(false);
const carregado = ref(false);

const groupUserFilter = ref("");
const filteredUsersForGroup = computed(() => {
  if (!groupUserFilter.value) return users.value;
  const search = groupUserFilter.value.toLowerCase();
  return users.value.filter(u => u.name.toLowerCase().includes(search));
});

async function ensureUsersLoaded() {
  if (users.value.length === 0) {
    await loadUsers();
  }
}

async function ensureGroupsLoaded() {
  if (groups.value.length === 0) {
    await loadGroups();
  }
}



async function carregarPermissoes() {
  try {
    const response = await apiClient.get('/api/v1/files/permissions/');
    const permissoes = response.data.groups || [];
    sessionStorage.setItem('permissoes', JSON.stringify(permissoes));
  } catch (error) {
    console.error('Erro ao carregar permissões:', error);
  }
}

function verificarPermissaoResponsavel() {
  const permissoes = JSON.parse(sessionStorage.getItem('permissoes') || '[]');
  ehResponsavel.value = permissoes.includes('responsavel_setor') ||
    permissoes.includes('superadmin') ||
    permissoes.includes('desenvolvedor');
}

const isResponsible = computed(() => ehResponsavel.value);

// Verifica se o usuário é gestor (manager, superadmin ou engenhariaclinica)
const isManager = computed(() => {
  const groups = sessionStorage.getItem('user_groups');
  const userGroups = groups ? JSON.parse(groups) : [];
  return userGroups.some(group => ['manager', 'superadmin'].includes(group));
});

// Propriedades computadas para formulário de troca
const myOnCallDuties = computed(() => {
  // Usar a variável específica para plantões do usuário
  if (!Array.isArray(userOnCallDuties.value)) {
    return [];
  }
  
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Zerar horas para comparar apenas a data
  
  // Filtrar apenas plantões futuros que estão pendentes ou aprovados
  return userOnCallDuties.value.filter(duty => {
    const dutyDate = new Date(duty.date);
    dutyDate.setHours(0, 0, 0, 0);
    
    return (duty.status === 'pending' || duty.status === 'approved') && 
           dutyDate >= today;
  });
});

// Função para carregar plantões específicos do usuário
async function loadUserOnCallDuties(userId = null) {
  try {
    const params = {};
    if (userId) params.user_id = userId;
    
    const response = await apiClient.get('/api/v1/daysoff/oncall/user-duties/', { params });
    const results = response.data.results || [];
    
    
    return results;
  } catch (error) {
    console.error('Erro ao carregar plantões do usuário:', error);
    return [];
  }
}

// Esta computed foi substituída pela função loadAvailableUsersForSwap() e a variável availableUsersForSwap

const users = ref([]);
const requests = ref([]); // Solicitações de folga
const groups = ref([]);   // Grupos de usuários
const totalPages = ref(1);
const totalCount = ref(0);

async function loadUsers() {
  try {
    const response = await apiClient.get('/api/v1/auth/users/');
    users.value = response.data.map(u => ({
      id: u.id,
      name: `${u.first_name} ${u.last_name}`,
      email: u.email,
      groups: u.groups,
    }));
  } catch (error) {
    console.error('Erro ao carregar usuários:', error);
    errorMessage.value = 'Erro ao carregar usuários.';
    showErrorPopup.value = true;
  }
}

const timeOffBalances = ref([]);

async function loadBalances() {
  try {
    const response = await apiClient.get('/api/v1/daysoff/timeoff/balances/');
    timeOffBalances.value = response.data.map(b => ({
      ...b,
      userId: b.user_id
    }));
  } catch (error) {
    console.error('Erro ao carregar saldos de folga:', error);
    errorMessage.value = 'Erro ao carregar saldos.';
    showErrorPopup.value = true;
  }
}

// Funções para Plantão
async function loadOnCallDuties(month = null, year = null) {
  loadingOnCallDuties.value = true;
  try {
    const response = await apiClient.get('/api/v1/daysoff/oncall/duties/', {
      params: {
        month: (month || selectedMonth.value) + 1,
        year: year || selectedYear.value,
        status: onCallStatusFilter.value !== 'all' ? onCallStatusFilter.value : undefined,
        search: onCallFilter.value || undefined,
        group: selectedGroupId.value !== 'all' ? selectedGroupId.value : undefined
      }
    });
    // Handle both paginated response and direct array response
    onCallDuties.value = response.data.results || response.data || [];
  } catch (error) {
    console.error('Erro ao carregar escalas de plantão:', error);
    errorMessage.value = 'Erro ao carregar escalas de plantão.';
    showErrorPopup.value = true;
    onCallDuties.value = [];
  } finally {
    loadingOnCallDuties.value = false;
  }
}

async function loadOnCallSwapRequests() {
  try {
    const response = await apiClient.get('/api/v1/daysoff/oncall/swap-requests/', {
      params: {
        status: 'all',
        month: selectedMonth.value + 1,
        year: selectedYear.value
      }
    });
    // Handle both paginated response and direct array response
    onCallSwapRequests.value = response.data.results || response.data || [];
  } catch (error) {
    console.error('Erro ao carregar solicitações de troca:', error);
    errorMessage.value = 'Erro ao carregar solicitações de troca.';
    showErrorPopup.value = true;
    onCallSwapRequests.value = [];
  }
}

// Em gestaofolgas.vue

// Em gestaofolgas.vue

async function loadAvailability(groupId, startDate, endDate) {
  try {
    const response = await apiClient.get(`/api/v1/daysoff/oncall/availability/period/`, {
      params: { 
        group_id: groupId, 
        start_date: startDate,
        end_date: endDate
      }
    });
    
    // Simplesmente pega os dados que vêm da API.
    // O backend já garante que todos os membros têm um registo 
    // com 'available: true' por defeito.
    const availabilities = response.data.results || response.data || [];
    
    // Carrega todos os membros do grupo e mescla com as disponibilidades
    const group = groups.value.find(g => g.id === groupId);
    const allMembers = group ? group.members : [];
    
    // Limpa o array antes de recarregar
    availabilityForm.value.availableUsers = [];
    
    // Mapeia todos os membros do grupo com suas respectivas disponibilidades
    availabilityForm.value.availableUsers = allMembers.map(member => {
      const avail = availabilities.find(a => a.user_id === member.id);
      return {
        userId: member.id,
        available: avail ? avail.available : true, // Padrão: true se não houver registro
        unavailableReason: avail ? avail.unavailable_reason : '',
        userName: member.name // Adiciona o nome do usuário
      };
    });

    console.log('Disponibilidades carregadas:', availabilityForm.value.availableUsers);

  } catch (error) {
    console.error('Erro ao carregar disponibilidades:', error);
    availabilityForm.value.availableUsers = []; // Limpa em caso de erro.
  }
}




function openOnCallOrganizeModal() {
  // Abrir modal para organizar plantão do mês
  if (!isManager.value && !isResponsible.value) {
    alert('Apenas gestores e responsáveis podem organizar plantões.');
    return;
  }
  showOnCallOrganizeModal.value = true;
}

async function openAvailabilityModal(groupId = null) {
  showAvailabilityModal.value = true;
  availabilityForm.value.groupId = groupId || (userGroups.value.length > 0 ? userGroups.value[0].id : '');
  
  // Definir período padrão (próximos 30 dias)
  const today = new Date();
  const endDate = new Date();
  endDate.setDate(today.getDate() + 30);
  
  availabilityForm.value.startDate = today.toISOString().split('T')[0];
  availabilityForm.value.endDate = endDate.toISOString().split('T')[0];
  
  // Carregar disponibilidades do período
  if (availabilityForm.value.groupId) {
    await loadAvailability(availabilityForm.value.groupId, availabilityForm.value.startDate, availabilityForm.value.endDate);
  }
}

async function saveOnCallOrganization() {
  if (isOrganizing.value) return;
  
  isOrganizing.value = true;
  organizeError.value = '';
  organizeSuccess.value = ''
  
  try {
    // Preparar os dados para envio
    const assignments = [];
    for (const saturday of monthSaturdays.value) {
      const primaryUserId = organizeForm.value.assignments[saturday.date];
      const secondaryUserId = organizeForm.value.assignments[saturday.date + '_secondary'];
      
      // Verificar se pelo menos um colaborador foi selecionado
      if (primaryUserId || secondaryUserId) {
        const userIds = [];
        if (primaryUserId) userIds.push(primaryUserId);
        if (secondaryUserId) userIds.push(secondaryUserId);
        
        assignments.push({
          date: saturday.date,
          user_ids: userIds, // Enviar array de user_ids
          group_id: organizeForm.value.groupId
        });
      }
    }
    
    if (assignments.length === 0) {
      organizeError.value = 'Por favor, defina pelo menos um plantão.';
      return;
    }
    
    // Usar a nova função de organização de escala que cria plantões diretamente aprovados
    await apiClient.post('/api/v1/daysoff/oncall/organize-scale/', {
      group_id: organizeForm.value.groupId,
      assignments: assignments
    });
    
    organizeSuccess.value = 'Plantões organizados com sucesso!';
    await loadRequests(); 
    // Recarregar dados
    await loadOnCallDuties();
    
    // Limpar formulário após 2 segundos e fechar modal
    setTimeout(() => {
      organizeForm.value.assignments = {};
      organizeSuccess.value = '';
      closeOnCallOrganizeModal();
    }, 2000);
    
  } catch (error) {
    console.error('Erro ao organizar plantões:', error);
    organizeError.value = 'Erro ao organizar plantões. Verifique se já existem plantões para as datas selecionadas.';
  } finally {
    isOrganizing.value = false;
  }
}

async function saveAvailability() {
  if (isSavingAvailability.value) return;
  
  isSavingAvailability.value = true;
  availabilityError.value = '';
  availabilitySuccess.value = '';
  
  try {
    // Garantir que todos os membros do grupo estão incluídos
    const group = groups.value.find(g => g.id === availabilityForm.value.groupId);
    if (!group || !group.members) {
      throw new Error('Grupo não encontrado ou sem membros');
    }
    
    // Criar mapa de disponibilidades atuais
    const currentAvailabilityMap = {};
    availabilityForm.value.availableUsers.forEach(user => {
      currentAvailabilityMap[user.userId] = user;
    });
    
    // Criar lista completa com todos os membros do grupo
    const completeAvailabilityData = group.members.map(member => {
      const currentAvailability = currentAvailabilityMap[member.id];
      if (currentAvailability) {
        return {
          user_id: currentAvailability.userId,
          available: currentAvailability.available,
          unavailable_reason: currentAvailability.unavailableReason || '',
          group_id: availabilityForm.value.groupId,
          start_date: availabilityForm.value.startDate,
          end_date: availabilityForm.value.endDate
        };
      } else {
        // Usuário não está na lista - adicionar como disponível por padrão
        return {
          user_id: member.id,
          available: true,
          unavailable_reason: '',
          group_id: availabilityForm.value.groupId,
          start_date: availabilityForm.value.startDate,
          end_date: availabilityForm.value.endDate
        };
      }
    });
    
    console.log('Payload enviado para o backend:', completeAvailabilityData);
    // Enviar todas as disponibilidades usando o novo endpoint para período
    await apiClient.post('/api/v1/daysoff/oncall/availability/bulk-update-period/', {
      availabilities: completeAvailabilityData
    });
    
    showBannerMessage('Disponibilidades salvas com sucesso!', 'success');
    
    // Recarregar as disponibilidades para garantir que o frontend está sincronizado
    await loadAvailability(availabilityForm.value.groupId, availabilityForm.value.startDate, availabilityForm.value.endDate);
    
    // Fechar modal imediatamente
    closeAvailabilityModal();
    
  } catch (error) {
    console.error('Erro ao salvar disponibilidades:', error);
    showBannerMessage('Erro ao salvar disponibilidades.', 'error');
    closeAvailabilityModal();
  } finally {
    isSavingAvailability.value = false;
  }
}

async function openOnCallSwapModal() {
  // Abrir modal para solicitar troca
  // Limpar formulário ao abrir
  swapForm.value = {
    myDutyId: '',
    targetUserId: '',
    reason: ''
  };
  swapError.value = '';
  swapSuccess.value = '';
  
  try {
    // Garantir que os grupos estejam carregados
    if (groups.value.length === 0) {
      await loadGroups();
    }
    
    // Carregar plantões específicos do usuário atual
    const userDuties = await loadUserOnCallDuties();
    // Atualizar a lista de plantões do usuário
    userOnCallDuties.value = userDuties;
    
    
  } catch (error) {
    console.error('Erro ao carregar dados para troca:', error);
    swapError.value = 'Erro ao carregar dados. Tente novamente.';
  }
  
  showOnCallSwapModal.value = true;
}

// Função para carregar usuários disponíveis quando um plantão é selecionado
async function loadAvailableUsersForSwap() {
  if (!swapForm.value.myDutyId) {
    availableUsersForSwap.value = [];
    return;
  }
  
  try {
    // Encontrar o plantão selecionado
    const selectedDuty = userOnCallDuties.value.find(duty => duty.id == swapForm.value.myDutyId);
    
    if (!selectedDuty || !selectedDuty.group_id) {
      availableUsersForSwap.value = [];
      return;
    }
    
    // Buscar o grupo
    const group = groups.value.find(g => g.id == selectedDuty.group_id);
    
    if (!group || !group.members) {
      availableUsersForSwap.value = [];
      return;
    }
    
    // Filtrar membros, exceto o usuário atual
    const currentUserId = userStore.user?.id;
    availableUsersForSwap.value = group.members.filter(member => member.id != currentUserId);
    
    
  } catch (error) {
    console.error('Erro ao carregar usuários disponíveis:', error);
    availableUsersForSwap.value = [];
  }
}

// Em <script setup> de GestaoFolgas.vue

// Em <script setup> de GestaoFolgas.vue

// APAGUE AS FUNÇÕES generateSimpleRotatingScale e generateSmartScaleFromExistingDuties
// E SUBSTITUA A generateAutomaticScale por esta:
// NOVA FUNÇÃO UNIFICADA (USE ESTA)
async function generateAndSaveAutomaticScale() {
  if (!availabilityForm.value.groupId) {
    availabilityError.value = 'Por favor, selecione um grupo.';
    return;
  }
  
  // Ativa o estado de "gerando"
  isGeneratingScale.value = true;
  availabilityError.value = '';
  availabilitySuccess.value = '';
  autoScaleAssignments.value = {}; // Limpa prévias antigas

  try {
    // --- ETAPA 1: GERAR A PRÉVIA DA ESCALA ---
    const generateResponse = await apiClient.get('/api/v1/daysoff/oncall/generate-projected-scale/', {
      params: {
        group_id: availabilityForm.value.groupId,
        start_date: availabilityForm.value.startDate,
        end_date: availabilityForm.value.endDate,
      }
    });

    const projectedAssignments = generateResponse.data;

    // Valida se a escala foi gerada com sucesso
    if (!projectedAssignments || Object.keys(projectedAssignments).length === 0 || projectedAssignments.error) {
      const errorMessage = projectedAssignments.error || 'Não foi possível gerar a escala. Verifique se o grupo tem membros ou se já existem plantões manuais para servir de base.';
      showBannerMessage(errorMessage, 'warning');
      closeAvailabilityModal();
      return; // Interrompe a execução se a geração falhar
    }

    // --- ETAPA 2: PREPARAR E SALVAR A ESCALA GERADA ---
    availabilitySuccess.value = 'Escala projetada com sucesso. Salvando...';

    const scaleData = {
      group_id: availabilityForm.value.groupId,
      assignments: projectedAssignments // Envia a escala gerada
    };
    
    const saveResponse = await apiClient.post('/api/v1/daysoff/oncall/save-automatic-scale/', scaleData);
    
    if (saveResponse.data.success) {
      showBannerMessage('Escala automática gerada e salva com sucesso!', 'success');
      
      // Recarrega os dados para atualizar o calendário
      await loadOnCallDuties();
      
      // Fecha o modal imediatamente
      closeAvailabilityModal();

    } else {
      const errorMessage = saveResponse.data.error || 'Erro ao salvar a escala automática gerada.';
      showBannerMessage(errorMessage, 'error');
      closeAvailabilityModal();
    }
    
  } catch (error) {
    console.error('Erro no processo de geração e salvamento da escala:', error);
    showBannerMessage('Ocorreu um erro inesperado. Verifique o console para mais detalhes.', 'error');
    closeAvailabilityModal();
  } finally {
    // Desativa o estado de "gerando"
    isGeneratingScale.value = false;
  }
}

  

  
        
  
function toggleUserAvailability(userId) {
  const user = availabilityForm.value.availableUsers.find(u => u.userId === userId);
  if (user) {
    // Alterna disponibilidade: se estava disponível (true), fica indisponível (false)
    user.available = !user.available;
    // Se ficou indisponível, pedir motivo
    if (!user.available) {
      const reason = prompt('Motivo da indisponibilidade (opcional):');
      user.unavailableReason = reason || '';
    } else {
      // Se voltou a ficar disponível, limpar motivo
      user.unavailableReason = '';
    }
  } else {
    // Se não existe, criar com disponível = false (indisponível)
    const reason = prompt('Motivo da indisponibilidade (opcional):');
    availabilityForm.value.availableUsers.push({
      userId: userId,
      available: false, // Indisponível por padrão
      unavailableReason: reason || ''
    });
  }
}

async function addComment() {
  if (!newComment.value.trim() || !selectedRequest.value) return;
  try {
    await apiClient.post(`/api/v1/daysoff/timeoff/requests/${selectedRequest.value.id}/comment/`, {
      text: newComment.value
    });
    await loadRequests();  // Atualiza para refletir o novo comentário
    newComment.value = '';
  } catch (error) {
    console.error('Erro ao adicionar comentário:', error);
    errorMessage.value = 'Erro ao adicionar comentário.';
    showErrorPopup.value = true;
  }
}

async function saveBalanceAdjustment() {
  if (isSavingBalanceAdjustment.value) return;
  isSavingBalanceAdjustment.value = true;
  if (!balanceAdjustmentReason.value.trim()) {
    errorMessage.value = "Informe o motivo do ajuste.";
    showErrorPopup.value = true;
    isSavingBalanceAdjustment.value = false;
    return;
  }
  if (!selectedUserForBalance.value) {
    errorMessage.value = "Nenhum usuário selecionado para ajuste.";
    showErrorPopup.value = true;
    isSavingBalanceAdjustment.value = false;
    return;
  }
  
  // Confirmação para saldo negativo
  if (willBeNegative.value) {
    const confirmed = window.confirm(
      `ATENÇÃO: Este ajuste resultará em um saldo negativo de ${calculatedBalance.value} dias.\n\n` +
      `Saldo atual: ${getUserBalance(selectedUserForBalance.value.id).available} dias + ${balanceAdjustment.value} (ajuste) = ${calculatedBalance.value} dias.\n\n` +
      `Deseja continuar com este ajuste?`
    );
    if (!confirmed) {
      isSavingBalanceAdjustment.value = false;
      return;
    }
  }
  
  try {
    await apiClient.put(`/api/v1/daysoff/timeoff/balances/${selectedUserForBalance.value.id}/`, {
      available: balanceAdjustment.value,
      reason: balanceAdjustmentReason.value
    });
    await loadBalances();
    closeAdjustBalanceModal();
  } catch (error) {
    console.error('Erro ao ajustar saldo:', error);
    errorMessage.value = 'Erro ao ajustar saldo de folgas.';
    showErrorPopup.value = true;
  } finally {
    isSavingBalanceAdjustment.value = false;
  }
}


const userGroups = computed(() => {
  if (!userStore.id) return [];
  return groups.value.filter(group => group.members.includes(userStore.id));
});

const tomorrow = computed(() => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow.toISOString().split('T')[0];
});

const today = computed(() => {
  return new Date().toISOString().split('T')[0];
});




 
const filteredUsersForBalance = computed(() => {
  // 1) pega apenas os grupos que eu criei (i.e. onde sou gestor)
  const meusGrupos = groups.value.filter(g => g.created_by === userStore.id);

  // 2) cria um Set com IDs de todos os membros desses grupos
  const membroIds = new Set();
  meusGrupos.forEach(g => {
    g.members.forEach(m => {
      membroIds.add(m.id);
    });
  });

  // 3) filtra a lista de todos os usuários, mantendo só quem estiver nesses grupos
  let lista = users.value.filter(u => membroIds.has(u.id));

  // 4) se houver texto digitado no balanceFilter, filtra por nome
  if (balanceFilter.value) {
    const termo = balanceFilter.value.toLowerCase();
    lista = lista.filter(u =>
      u.name.toLowerCase().includes(termo)
    );
  }

  return lista;
});

// Computed properties para organização de plantões
const months = computed(() => [
  { value: 0, label: 'Janeiro' },
  { value: 1, label: 'Fevereiro' },
  { value: 2, label: 'Março' },
  { value: 3, label: 'Abril' },
  { value: 4, label: 'Maio' },
  { value: 5, label: 'Junho' },
  { value: 6, label: 'Julho' },
  { value: 7, label: 'Agosto' },
  { value: 8, label: 'Setembro' },
  { value: 9, label: 'Outubro' },
  { value: 10, label: 'Novembro' },
  { value: 11, label: 'Dezembro' }
]);

const years = computed(() => {
  const currentYear = new Date().getFullYear();
  return [currentYear - 1, currentYear, currentYear + 1];
});

const monthSaturdays = computed(() => {
  if (!organizeForm.value.month && organizeForm.value.month !== 0) return [];
  
  const saturdays = [];
  const date = new Date(organizeForm.value.year, organizeForm.value.month, 1);
  const month = date.getMonth();
  
  // Encontrar o primeiro sábado do mês
  while (date.getDay() !== 6) {
    date.setDate(date.getDate() + 1);
  }
  
  // Adicionar todos os sábados do mês
  while (date.getMonth() === month) {
    saturdays.push({
      date: date.toISOString().split('T')[0],
      day: date.getDate(),
      label: date.toLocaleDateString('pt-BR', { weekday: 'short' })
    });
    date.setDate(date.getDate() + 7);
  }
  
  return saturdays;
});

const availableUsers = computed(() => {
  if (!organizeForm.value.groupId) return [];
  
  const group = groups.value.find(g => g.id === organizeForm.value.groupId);
  if (!group || !group.members) return [];
  
  return group.members.map(member => {
    // Use o membro completo que já vem com id e name do backend
    return member;
  }).filter(member => member);
});

const availableUsersForGroup = computed(() => {
  if (!availabilityForm.value.groupId) return [];
  
  const group = groups.value.find(g => g.id === availabilityForm.value.groupId);
  if (!group || !group.members) return [];
  
  return group.members.map(member => {
    // Use o membro completo que já vem com id e name do backend
    return member;
  }).filter(member => member);
});



// Métodos
function ordenarPor(coluna) {
  if (colunaOrdenada.value === coluna) {
    ordemAscendente.value = !ordemAscendente.value;
  } else {
    colunaOrdenada.value = coluna;
    ordemAscendente.value = true;
  }
  // Define o campo de ordenação para o backend
  switch (coluna) {
    case 'nome':
      ordering.value = ordemAscendente.value ? 'user__first_name' : '-user__first_name';
      break;
    case 'data':
      ordering.value = ordemAscendente.value ? 'date' : '-date';
      break;
    case 'motivo':
      ordering.value = ordemAscendente.value ? 'reason' : '-reason';
      break;
    case 'status':
      ordering.value = ordemAscendente.value ? 'status' : '-status';
      break;
    default:
      ordering.value = '-date';
  }
  loadRequests();
}

function formatDate(dateString) {
  if (!dateString) return '';
  // Exibe a data no formato dd/mm/yyyy sem usar new Date()
  const [yyyy, mm, dd] = dateString.split('-');
  return `${dd}/${mm}/${yyyy}`;
}

function formatDateTime(date) {
  if (!date) return '';
  const d = (date instanceof Date) ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR') + ' ' +
    d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

function getStatusText(status) {
  const statusMap = {
    pending: 'Aguardando',
    approved: 'Aprovada',
    rejected: 'Rejeitada'
  };
  return statusMap[status] || status;
}




function getUserBalance(userId) {
  const balance = timeOffBalances.value.find(b => b.userId === userId);
  return {
    available: balance ? balance.available : 0,
    pending: balance ? balance.pending : 0,
    used: balance ? balance.used : 0
  };
}


function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
    loadRequests();
  }
}

function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
    loadRequests();
  }
}



// Funções de modal
async function openRequestModal(request = null) {
  await ensureUsersLoaded(); // Garante que usuários estejam carregados
  await loadGroups(); // Sempre carrega os grupos ao abrir o modal
  isEditMode.value = !!request;
  if (request) {
    currentRequest.value = { ...request };
  } else {
    // Selecionar grupo automaticamente se houver apenas 1 grupo disponível
    let defaultGroupId = null;
    if (userGroups.value.length === 1) {
      defaultGroupId = userGroups.value[0].id;
    } else if (groups.value.length === 1) {
      defaultGroupId = groups.value[0].id;
    }
    currentRequest.value = {
      id: null,
      userId: userStore.id,
      groupId: defaultGroupId,
      date: '',
      reason: 'Particular',
      status: 'pending',
      comments: []
    };
  }
  showRequestModal.value = true;
}

function closeRequestModal() {
  showRequestModal.value = false;
  currentRequest.value = {
    id: null,
    userId: userStore.id,
    groupId: null,
    date: '',
    reason: '',
    status: 'pending',
    comments: []
  };
}

async function loadGroups() {
  try {
    const response = await apiClient.get('/api/v1/daysoff/groups/');
    groups.value = response.data.map(g => ({
      ...g,
      members: g.members // ✅ mantém como array de objetos { id, name }
    }));
    
  } catch (error) {
    console.error('Erro ao carregar grupos:', error);
    errorMessage.value = 'Erro ao carregar grupos.';
    showErrorPopup.value = true;
  }
}


async function approveSwapRequest(swap) {
  if (isApprovingRequest.value) return;
  
  const confirmApprove = window.confirm(`Tem certeza que deseja aprovar esta solicitação de troca de plantão?`);
  if (!confirmApprove) return;
  
  isApprovingRequest.value = true;
  try {
    // Usamos o 'original_id' que definimos no backend
    await apiClient.post(`/api/v1/daysoff/oncall/swap-requests/${swap.original_id}/approve/`);
    await loadRequests(); // Recarrega a lista unificada
    await loadOnCallDuties(); // Recarrega os plantões
  } catch (error) {
    console.error('Erro ao aprovar troca:', error);
    errorMessage.value = error.response?.data?.detail || 'Erro ao aprovar a troca de plantão.';
    showErrorPopup.value = true;
  } finally {
    isApprovingRequest.value = false;
  }
}

async function rejectSwapRequest(swap) {
  if (isRejectingRequest.value) return;
  
  const reason = prompt('Informe o motivo da rejeição (opcional):');
  if (reason === null) return; // Usuário cancelou
  
  isRejectingRequest.value = true;
  try {
    // Usamos o 'original_id' que definimos no backend
    await apiClient.post(`/api/v1/daysoff/oncall/swap-requests/${swap.original_id}/reject/`, {
      reason: reason || ''
    });
    await loadRequests(); // Recarrega a lista unificada
    await loadOnCallDuties(); // Recarrega os plantões
  } catch (error) {
    console.error('Erro ao rejeitar troca:', error);
    errorMessage.value = error.response?.data?.detail || 'Erro ao rejeitar a troca de plantão.';
    showErrorPopup.value = true;
  } finally {
    isRejectingRequest.value = false;
  }
}

async function loadRequests() {
  try {
    // ... (o início da função pode ser mantido se você tiver lógicas complexas)

    // ATENÇÃO: A lógica do calendário agora busca dados separados.
    // Apenas a aba 'requests' usará o endpoint combinado.
    if (activeTab.value === 'calendar') {
      // Lógica para carregar folgas E plantões para o calendário
      const paramsCalendar = {
        year: currentDate.value.getFullYear(),
        month: currentDate.value.getMonth() + 1,
        exclude_auto_generated: true,
      };
      const [requestsResponse, dutiesResponse] = await Promise.all([
        apiClient.get('/api/v1/daysoff/timeoff/requests/', { params: paramsCalendar }),
        apiClient.get('/api/v1/daysoff/oncall/duties/', { params: { year: paramsCalendar.year, month: paramsCalendar.month } })
      ]);

      requests.value = requestsResponse.data.results.map(req => ({ ...req, userId: req.user_id }));
      onCallDuties.value = dutiesResponse.data.results || dutiesResponse.data || [];
      return; // Finaliza aqui para o calendário
    }

    // Lógica para a aba 'requests' (agora com o endpoint combinado)
    const params = {
      page: currentPage.value,
      page_size: itemsPerPage.value,
      ordering: ordering.value,
    };
    if (statusFilter.value !== 'all') {
      params.status = statusFilter.value;
    }
    if (selectedGroupId.value !== 'all') {
      params.group_id = selectedGroupId.value;
    }
    if (filter.value) {
      params.search = filter.value;
    }

    // CHAMA O NOVO ENDPOINT
    const response = await apiClient.get('/api/v1/daysoff/combined-requests/', { params });

    requests.value = response.data.results; // A resposta já vem formatada
    totalPages.value = response.data.num_pages;
    totalCount.value = response.data.count;

  } catch (error) {
    console.error('Erro ao carregar solicitações:', error);
    errorMessage.value = 'Erro ao carregar solicitações.';
    showErrorPopup.value = true;
  }
}


async function saveRequest() {
  if (isSavingRequest.value) return;
  isSavingRequest.value = true;
  try {
    if (!currentRequest.value.groupId) {
      errorMessage.value = 'Selecione um grupo antes de salvar.';
      showErrorPopup.value = true;
      return;
    }

    const payload = {
      date: currentRequest.value.date,
      reason: currentRequest.value.reason,
      group_id: currentRequest.value.groupId,
    };

    if (isEditMode.value) {
      await apiClient.put(`/api/v1/daysoff/timeoff/requests/${currentRequest.value.id}/`, payload);
    } else {
      await apiClient.post('/api/v1/daysoff/timeoff/requests/', payload);
    }

    statusFilter.value = 'all';
    selectedGroupId.value = 'all';

    closeRequestModal();
    await loadRequests();
  } catch (error) {
    // Mostra mensagem personalizada do backend (403)
    if (error.response && error.response.status === 403 && error.response.data && error.response.data.detail) {
      errorMessage.value = error.response.data.detail;
    } else {
      errorMessage.value = 'Erro ao salvar a solicitação. Tente novamente.';
    }
    showErrorPopup.value = true;
  } finally {
    isSavingRequest.value = false;
  }
}

// VERSÃO CORRIGIDA
async function approveRequest(request) {
  if (isApprovingRequest.value) return;
  isApprovingRequest.value = true;
  try {
    // Usamos o 'original_id' para garantir que estamos enviando um número para o backend
    await apiClient.post(`/api/v1/daysoff/timeoff/requests/${request.original_id}/approve/`);
    // Recarregar as solicitações após aprovação
    await loadRequests();
  } catch (error) {
    console.error('Erro ao aprovar a solicitação:', error);
    // Adicione feedback de erro para o usuário
    errorMessage.value = 'Erro ao aprovar a solicitação de folga.';
    showErrorPopup.value = true;
  } finally {
    isApprovingRequest.value = false;
  }
}

function openRejectModal(request) {
  selectedRequest.value = request;
  rejectReason.value = '';
  showRejectModal.value = true;
}

function closeRejectModal() {
  showRejectModal.value = false;
  selectedRequest.value = null;
  rejectReason.value = '';
}

async function rejectRequest() {
  if (isRejectingRequest.value) return;
  isRejectingRequest.value = true;
  try {
    const rawId = selectedRequest.value?.original_id ?? selectedRequest.value?.id;
    const requestId = Number(
      typeof rawId === 'string' && rawId.includes('-')
        ? rawId.split('-').pop()
        : rawId
    );

    if (!Number.isInteger(requestId) || requestId <= 0) {
      throw new Error('ID de solicitação inválido para rejeição.');
    }

    await apiClient.post(`/api/v1/daysoff/timeoff/requests/${requestId}/reject/`, {
      reason: rejectReason.value
    });
    closeRejectModal();
    // Recarregar as solicitações após a rejeição
    await loadRequests();
  } catch (error) {
    console.error('Erro ao rejeitar a solicitação:', error);
    errorMessage.value = 'Erro ao rejeitar a solicitação. Tente novamente.';
    showErrorPopup.value = true;
  } finally {
    isRejectingRequest.value = false;
  }

  const selectedId = selectedRequest.value ? selectedRequest.value.id : null;
  if (selectedId !== null) {
    const index = requests.value.findIndex(r => r.id === selectedId);
    if (index !== -1) {
      requests.value[index].status = 'rejected';
      // Adicionar comentário com o motivo da rejeição
      if (!requests.value[index].comments) {
        requests.value[index].comments = [];
      }
      requests.value[index].comments.push({
        userId: userStore.id,
        text: rejectReason.value,
        timestamp: new Date()
      });
    }
  }
  closeRejectModal();
}

function viewRequestDetails(request) {
  selectedRequest.value = request;
  newComment.value = '';
  showDetailsModal.value = true;
  showDayModal.value = false; // Fecha o modal do dia ao abrir detalhes
}

function closeDetailsModal() {
  showDetailsModal.value = false;
  selectedRequest.value = null;
  newComment.value = '';
}

function openGroupModal(group = null) {
  ensureUsersLoaded(); // Carrega usuários para marcar membros
  ensureGroupsLoaded(); // Garante que os grupos estão carregados

  isEditGroupMode.value = !!group;
  if (group) {
    currentGroup.value = {
      ...group,
      members: group.members.map(m => typeof m === 'object' ? m.id : m)
    };
  } else {
    currentGroup.value = {
      id: null,
      name: '',
      members: userStore.id ? [userStore.id] : []
    };
  }
  showGroupModal.value = true;
}


function closeGroupModal() {
  showGroupModal.value = false;
  currentGroup.value = {
    id: null,
    name: '',
    members: []
  };
}

async function saveGroup() {
  if (isSavingGroup.value) return;
  isSavingGroup.value = true;
  if (!currentGroup.value.name.trim()) {
    errorMessage.value = "Por favor, informe o nome do grupo.";
    showErrorPopup.value = true;
    isSavingGroup.value = false;
    return;
  }

  const membrosInteiros = (currentGroup.value.members || [])
    .filter(id => id !== null && id !== undefined && id !== '')
    .map(id => Number(id))
    .filter(id => Number.isInteger(id) && id > 0);

  if (membrosInteiros.length === 0) {
    errorMessage.value = "Por favor, selecione pelo menos um membro para o grupo.";
    showErrorPopup.value = true;
    isSavingGroup.value = false;
    return;
  }

  // Garante que o coordenador esteja incluso
  if (userStore.id && !membrosInteiros.includes(userStore.id)) {
    membrosInteiros.push(userStore.id);
  }

  try {
        const payload = {
          name: currentGroup.value.name,
          members: membrosInteiros,
        };

        let response;
        if (isEditGroupMode.value && currentGroup.value.id) {
          response = await apiClient.put(`/api/v1/daysoff/groups/${currentGroup.value.id}/`, payload);
        } else {
          response = await apiClient.post('/api/v1/daysoff/groups/', payload);
        }

        // Verificar se houve reorganização de plantões
        if (response.data && response.data.reorganized_duties) {
          alert('Atenção: A remoção de membros resultou na reorganização automática de plantões futuros. Os envolvidos serão notificados.');
        }

        await loadGroups();
        closeGroupModal();
  } catch (error) {
    console.error("Erro ao salvar grupo:", error);
    errorMessage.value = "Erro ao salvar grupo. Tente novamente.";
    showErrorPopup.value = true;
  } finally {
    isSavingGroup.value = false;
  }
}

async function deleteGroup(groupId) {
  const confirmDelete = window.confirm("Tem certeza que deseja excluir este grupo?");
  if (!confirmDelete) return;

  // Verificar se há solicitações associadas a este grupo
  const hasRequests = requests.value.some(r => r.groupId === groupId);
  if (hasRequests) {
    const confirmDeleteWithRequests = window.confirm("Este grupo possui solicitações associadas. Deseja excluir mesmo assim?");
    if (!confirmDeleteWithRequests) return;
  }

  try {
    await apiClient.delete(`/api/v1/daysoff/groups/${groupId}/`);
    await loadGroups(); // Recarrega os grupos do backend
  } catch (error) {
    console.error('Erro ao excluir grupo:', error);
    errorMessage.value = 'Erro ao excluir grupo. Tente novamente.';
    showErrorPopup.value = true;
  }
}

async function openBalanceModal() {
  await ensureUsersLoaded();
  await ensureGroupsLoaded();
  await loadBalances(); // <-- FORÇA sempre que abrir
  showBalanceModal.value = true;
}


function closeBalanceModal() {
  showBalanceModal.value = false;
  balanceFilter.value = '';
}

function openAdjustBalanceModal(user) {
  selectedUserForBalance.value = user;
  // Inicializa com 0 para adicionar/remover dias (delta), não o valor absoluto
  balanceAdjustment.value = 0;
  balanceAdjustmentReason.value = '';
  showAdjustBalanceModal.value = true;
}

// Função para calcular o saldo resultante
const calculatedBalance = computed(() => {
  if (!selectedUserForBalance.value) return 0;
  const userBalance = timeOffBalances.value.find(b => b.userId === selectedUserForBalance.value.id);
  const currentAvailable = userBalance ? userBalance.available : 0;
  const delta = balanceAdjustment.value || 0;
  return currentAvailable + delta;
});

// Função para verificar se o saldo será negativo
const willBeNegative = computed(() => {
  return calculatedBalance.value < 0;
});

function closeAdjustBalanceModal() {
  showAdjustBalanceModal.value = false;
  selectedUserForBalance.value = null;
  balanceAdjustment.value = 0;
  balanceAdjustmentReason.value = '';
}

function incrementBalance() {
  balanceAdjustment.value++;
}

function decrementBalance() {
  balanceAdjustment.value--;
}

// 1. Adicione estados para o modal de edição de data
const showEditDateModal = ref(false);
const editDateValue = ref('');

function openEditDateModal(request) {
  selectedRequest.value = request;
  // Preencher a data sem conversão de timezone
  editDateValue.value = request.date ? request.date.substring(0, 10) : '';
  showEditDateModal.value = true;
}
function closeEditDateModal() {
  showEditDateModal.value = false;
  selectedRequest.value = null;
  editDateValue.value = '';
}
async function saveEditDate() {
  if (isSavingEditDate.value) return;
  isSavingEditDate.value = true;
  try {
    await apiClient.put(`/api/v1/daysoff/timeoff/requests/${selectedRequest.value.id}/`, {
      date: editDateValue.value,
      group_id: selectedRequest.value.groupId,
      reason: selectedRequest.value.reason,
      status: selectedRequest.value.status,
    });
    await loadRequests();
    closeEditDateModal();
  } catch (error) {
    // Mostra mensagem personalizada do backend (403)
    if (error.response && error.response.status === 403 && error.response.data && error.response.data.detail) {
      errorMessage.value = error.response.data.detail;
    } else {
      errorMessage.value = 'Erro ao editar a data da folga.';
    }
    showErrorPopup.value = true;
  } finally {
    isSavingEditDate.value = false;
  }
}

// 1. Adicione estados para o modal de dia do calendário
const showDayModal = ref(false);
const selectedDay = ref(null);
const dayRequests = ref([]);

function closeDayModal() {
  showDayModal.value = false;
  selectedDay.value = null;
  dayRequests.value = [];
}

function closeOnCallOrganizeModal() {
  showOnCallOrganizeModal.value = false;
}



function closeOnCallSwapModal() {
  showOnCallSwapModal.value = false;
}

function closeAvailabilityModal() {
  showAvailabilityModal.value = false;
  availabilityForm.value = {
    startDate: '',
    endDate: '',
    groupId: '',
    availableUsers: []
  };
  autoScaleAssignments.value = {};
}

function getUserName(userId) {
  // Primeiro tenta encontrar no array global de usuários
  const user = users.value.find(u => u.id === userId);
  if (user) return user.name;
  
  // Se não encontrar, procura nos membros dos grupos carregados
  for (const group of groups.value) {
    if (group.members) {
      const member = group.members.find(m => m.id === userId);
      if (member) return member.name;
    }
  }
  
  return 'Usuário Desconhecido';
}

async function saveSwapRequest() {
  if (isSwapping.value) return;
  
  if (!swapForm.value.myDutyId || !swapForm.value.targetUserId || !swapForm.value.reason) {
    swapError.value = 'Por favor, preencha todos os campos.';
    return;
  }
  
  isSwapping.value = true;
  swapError.value = '';
  swapSuccess.value = '';
  
  try {
    // Criar solicitação de troca
    await apiClient.post('/api/v1/daysoff/oncall/swap-requests/', {
      oncall_duty_id: swapForm.value.myDutyId,
      target_user_id: swapForm.value.targetUserId,
      reason: swapForm.value.reason
    });
    
    swapSuccess.value = 'Solicitação de troca enviada com sucesso!';
    
    // Recarregar dados
    await loadOnCallSwapRequests();
    
    // Limpar formulário após 2 segundos e fechar modal
    setTimeout(() => {
      swapForm.value = {
        myDutyId: '',
        targetUserId: '',
        reason: ''
      };
      swapSuccess.value = '';
      closeOnCallSwapModal();
    }, 2000);
    
  } catch (error) {
    console.error('Erro ao solicitar troca:', error);
    swapError.value = 'Erro ao solicitar troca. Verifique se já existe uma solicitação pendente para este plantão.';
  } finally {
    isSwapping.value = false;
  }
}

// Lifecycle hooks
onMounted(async () => {
  await carregarPermissoes();
  verificarPermissaoResponsavel();
  await loadUsers();    // primeiro carrega a lista de usuários
  await loadGroups();   // carrega os grupos
  // Carrega dado inicial da aba 'requests' (página 1)
  if (activeTab.value === 'requests') {
    await loadRequests();
  } else {
    // Caso você inicialize com activeTab diferente, ele carrega também:
    await loadRequests();
  }
  carregado.value = true;
});

const ordering = ref('-date');

// Atualize os watchers para filtros, itens por página e ordering
import { watch } from 'vue';
watch([filter, statusFilter, selectedGroupId, itemsPerPage], () => {
  currentPage.value = 1;
  loadRequests();
});
// Watcher para carregar usuários disponíveis quando um plantão é selecionado
watch(() => swapForm.value.myDutyId, () => {
  loadAvailableUsersForSwap();
});

// Adicionar watcher para activeTab
watch(activeTab, (nova) => {
  if (nova === 'calendar') {
    // Quando entrar na aba calendário, recarrega o mês vigente
    loadRequests();
  } else if (nova === 'requests') {
    // Se voltar para "requests", reinicia a página e recarrega
    currentPage.value = 1;
    loadRequests();
  } else if (nova === 'oncall') {
    // Quando entrar na aba plantão, carrega os dados de plantão
    loadOnCallDuties();
    loadOnCallSwapRequests();
  }
});

// 2) Ao mudar o `currentDate` (última aba "calendar"), recarrega automaticamente
watch(currentDate, () => {
  if (activeTab.value === 'calendar') {
    loadRequests();
  }
});

// 3) Continua observando filtros/funções de paginação apenas em "requests"
watch([filter, statusFilter, selectedGroupId, itemsPerPage], () => {
  if (activeTab.value === 'requests') {
    currentPage.value = 1;
    loadRequests();
  }
});

// 4) Watchers para o modal de disponibilidade
watch(() => availabilityForm.value.groupId, async (newGroupId) => {
  if (showAvailabilityModal.value && newGroupId && availabilityForm.value.startDate && availabilityForm.value.endDate) {
    await loadAvailability(newGroupId, availabilityForm.value.startDate, availabilityForm.value.endDate);
  }
});

watch(() => availabilityForm.value.startDate, async (newStartDate) => {
  if (showAvailabilityModal.value && availabilityForm.value.groupId && newStartDate && availabilityForm.value.endDate) {
    await loadAvailability(availabilityForm.value.groupId, newStartDate, availabilityForm.value.endDate);
  }
});

watch(() => availabilityForm.value.endDate, async (newEndDate) => {
  if (showAvailabilityModal.value && availabilityForm.value.groupId && availabilityForm.value.startDate && newEndDate) {
    await loadAvailability(availabilityForm.value.groupId, availabilityForm.value.startDate, newEndDate);
  }
});

// Watcher para recarregar usuários disponíveis quando o plantão for selecionado
watch(() => swapForm.value.myDutyId, () => {
  // Limpar seleção de usuário quando mudar o plantão
  swapForm.value.targetUserId = '';
});


const showGroupSelect = computed(() => {
  // Mostra o select se for gestor ou se o usuário faz parte de mais de um grupo
  return isResponsible.value || userGroups.value.length > 1;
});





// Estados de loading para evitar cliques duplos
const isSavingRequest = ref(false);
const isApprovingRequest = ref(false);
const isRejectingRequest = ref(false);
const isSavingGroup = ref(false);
const isSavingBalanceAdjustment = ref(false);
const isSavingEditDate = ref(false);

</script>
